import * as React from 'react';
export const notionSvg = React.forwardRef(function notionSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#D7E3E8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.94 8.695c.7.568.963.525 2.277.437l12.39-.744c.262 0 .044-.262-.044-.305l-2.058-1.488c-.394-.306-.92-.656-1.926-.569l-11.996.875c-.438.044-.525.263-.351.438l1.709 1.356Zm.745 2.887v13.035c0 .7.35.963 1.138.92l13.614-.788c.789-.043.877-.525.877-1.094V10.706c0-.568-.219-.874-.702-.83l-14.228.83c-.525.045-.7.307-.7.876Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.94 8.695c.7.568.963.525 2.277.437l12.39-.744c.262 0 .044-.262-.044-.305l-2.058-1.488c-.394-.306-.92-.656-1.926-.569l-11.996.875c-.438.044-.525.263-.351.438l1.709 1.356Zm.745 2.887v13.035c0 .7.35.963 1.138.92l13.614-.788c.789-.043.877-.525.877-1.094V10.706c0-.568-.219-.874-.702-.83l-14.228.83c-.525.045-.7.307-.7.876Zm13.44.7c.088.393 0 .787-.395.831l-.656.131v9.624c-.57.306-1.095.48-1.532.48-.701 0-.877-.218-1.401-.874l-4.29-6.736v6.518l1.357.306s0 .787-1.096.787l-3.02.175c-.088-.175 0-.612.307-.7l.788-.218v-8.618l-1.095-.088c-.087-.394.131-.962.744-1.006l3.24-.218 4.466 6.824v-6.037l-1.138-.131c-.088-.482.262-.832.7-.875l3.021-.176ZM6.575 5.72l12.479-.918c1.532-.132 1.927-.044 2.89.656l3.982 2.8c.657.48.877.611.877 1.136V24.75c0 .962-.35 1.531-1.577 1.618l-14.49.875c-.92.044-1.358-.087-1.84-.7l-2.933-3.806c-.526-.7-.744-1.224-.744-1.837V7.25c0-.787.35-1.444 1.357-1.53Z',
      fill: '#000',
    }),
  );
});
notionSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var notion = {
  category: 'brand',
  colorable: false,
  name: 'notion',
  svg: notionSvg,
};
